export const GET_COMPANY_MEMBERS = {
  START: "COMPANY/GET_MEMBERS_START",
  SUCCESS: "COMPANY/GET_MEMBERS_SUCCESS",
  ERROR: "COMPANY/GET_MEMBERS_ERROR",
  CLEAR: "COMPANY/CLEAR_MEMBERS",
};
